import React from 'react';

export default function ProgressBar({ value = 0, max = 1, color }) {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;
  const barColor = color || 'var(--gold)';

  return (
    <div style={{
      width: '100%',
      height: '6px',
      borderRadius: '3px',
      background: 'var(--beige, #E8DDD0)',
      overflow: 'hidden',
    }}>
      <div style={{
        width: `${pct}%`,
        height: '100%',
        borderRadius: '3px',
        background: barColor,
        transition: 'width 300ms ease',
      }} />
    </div>
  );
}
